import { StatBar } from '../stats/StatBar'
//import { Histogram } from '../stats/Histogram'
import { GameStats } from '../../lib/localStorage'
import { getShareStatus, shareStatus } from '../../lib/share'
import { BaseModal } from './BaseModal'

import { Attempt } from '../../../../common/types';

type Props = {
  isOpen: boolean
  handleClose: () => void
  guesses: Attempt[]
  gameStats: GameStats
  isGameLost: boolean
  isGameWon: boolean
  handleShare: () => void
  newGame: () => Promise<void>
}

export const StatsModal = ({
  isOpen,
  handleClose,
  guesses,
  gameStats,
  isGameLost,
  isGameWon,
  handleShare,
  newGame,
}: Props) => {
  if (gameStats.totalGames <= 0) {
    return (
      <BaseModal
        title={'Статистика'}
        isOpen={isOpen}
        handleClose={handleClose}
      >
        <StatBar gameStats={gameStats} />
      </BaseModal>
    )
  }

  /*
  <div>
            <h5>{NEW_WORD_TEXT}</h5>
            <Countdown
              className="text-lg font-medium text-gray-900 dark:text-gray-100"
              date={tomorrow}
              daysInHours={true}
            />
          </div>
  */

  const twitterLink = 'https://twitter.com/share?' + new URLSearchParams({
    'url': 'https://hardle.alextaran.net',
    'text': getShareStatus(guesses, isGameLost) + '\n#хардл\n\nОтгадайте слово на',
  }).toString();

  return (
    <BaseModal
      title={'Игра окончена!'}
      isOpen={isOpen}
      handleClose={handleClose}
    >
      {
        /*<StatBar gameStats={gameStats} />
          <h4 className="text-lg leading-6 font-medium text-gray-900 dark:text-gray-100">
            {'Распределение попыток'}
          </h4>
        <Histogram gameStats={gameStats} />*/
      }
      {(isGameLost || isGameWon) && (
        <div className="mt-5 sm:mt-6 columns-2 dark:text-white">
          <div>
            <button
              type="button"
              className="mt-2 w-full rounded-md border border-transparent shadow-sm px-4 py-2 bg-indigo-600 text-base font-medium text-white hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 sm:text-sm"
              onClick={() => newGame()}
            >
              {'Давай по новой!'}
            </button>  
          </div>
          
          
          <div>
          <button
              type="button"
              className="mt-2 w-full rounded-md border border-transparent shadow-sm px-4 py-2 bg-indigo-600 text-base font-medium text-white hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 sm:text-sm"
              onClick={() => {
                shareStatus(guesses, isGameLost)
                handleShare()
              }}
            >
              {'Поделиться'}
            </button>
            <button
              type="button"
              className="mt-2 w-full rounded-md border border-transparent shadow-sm px-4 py-2 bg-indigo-600 text-base font-medium text-white hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 sm:text-sm"
              onClick={() => {
                //shareStatus(guesses, isGameLost)
                window.open(twitterLink);
                handleShare()
              }}
            >
              {'В Твиттер'}
            </button>
          </div>

          
        </div>
      )}
    </BaseModal>
  )
}
